import React from 'react';
import './About.css';

function About() {
  const stats = [
    { number: '10+', label: 'Projects Delivered' },
    { number: '5+', label: 'Happy Clients' },
    { number: '2+', label: 'Years Experience' },
    { number: '50+', label: 'Professionals Placed' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About CodersPing</h2>
        <p className="section-subtitle">
          Your trusted partner in digital excellence
        </p>

        <div className="about-content">
          <div className="about-text">
            <h3>Who We Are</h3>
            <p>
              CodersPing is a leading software development and IT consultancy firm
              specializing in delivering cutting-edge solutions and premium staffing services.
              With a team of experienced professionals, we help businesses transform their
              digital presence and achieve their technology goals.
            </p>
            <p>
              Our mission is to empower organizations with innovative technology solutions
              and connect them with the best talent in the industry. We believe in building
              long-term partnerships based on trust, quality, and excellence.
            </p>
            <div className="values">
              <div className="value-item">
                <h4>🚀 Innovation</h4>
                <p>Staying ahead with latest technologies</p>
              </div>
              <div className="value-item">
                <h4>💎 Quality</h4>
                <p>Excellence in every line of code</p>
              </div>
              <div className="value-item">
                <h4>🤝 Partnership</h4>
                <p>Your success is our success</p>
              </div>
            </div>
          </div>

          <div className="about-stats">
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
